// ======================================================
// upsell-metafield.js (FINAL - no swiper, no conflicts)
// - Carousel: native scroll + arrows
// - Add to cart: intercept submit ONLY when upsell selected
//   => single /cart/add.js request (prevents double add)
// - Remove button: line-based /cart/change.js (stable)
// - Refresh: theme.miniCart.generateCart() if exists
// ======================================================

(function () {
  console.log("DU init (FINAL)");

  // -------------------------
  // Config
  // -------------------------
  const CART_DRAWER_REMOVE_SELECTOR = ".js-remove-mini-cart";
  const CART_DRAWER_ITEM_SELECTOR = ".mini-cart-item";
  const CART_DRAWER_LINE_INPUT_SELECTOR = 'input[data-line]';

  // -------------------------
  // Helpers
  // -------------------------
  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  async function refreshMiniCartHard() {
    try {
      if (window.theme && theme.miniCart) {
        if (typeof theme.miniCart.updateElements === "function") theme.miniCart.updateElements();
        if (typeof theme.miniCart.generateCart === "function") {
          theme.miniCart.generateCart();
          return;
        }
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    setTimeout(() => document.dispatchEvent(new CustomEvent("cart:refresh")), 250);
  }

  async function addItems(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items }),
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error("cart/add failed: " + res.status + " " + txt);
    }
    return res.json();
  }

  async function changeLine(line, qty) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) }),
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error("cart/change failed: " + res.status + " " + txt);
    }
    return res.json();
  }

  function findMainProductForm() {
    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    return forms[0] || null;
  }

  function getMainVariantIdFromForm(form) {
    const idInput = form.querySelector('[name="id"], [name=id]');
    return idInput ? idInput.value : null;
  }

  function getSelectedUpsellVariantIds(root) {
    return Array.from(root.querySelectorAll("[data-du-pick]:checked"))
      .map((i) => i.getAttribute("data-variant-id"))
      .filter(Boolean);
  }

  function getLineFromRemoveButton(btn) {
    // 1) data-line direkt varsa
    const dl = btn.getAttribute("data-line");
    if (dl) {
      const n = parseInt(dl, 10);
      return Number.isFinite(n) ? n : null;
    }

    // 2) aynı item içinde input[data-line] varsa
    const item = btn.closest(CART_DRAWER_ITEM_SELECTOR);
    const input = item && item.querySelector(CART_DRAWER_LINE_INPUT_SELECTOR);
    if (input) {
      const n = parseInt(input.getAttribute("data-line"), 10);
      return Number.isFinite(n) ? n : null;
    }

    return null;
  }

  // -------------------------
  // 1) Carousel (no swiper)
  // -------------------------
  function readCssVarNumber(el, name, fallback) {
    if (!el) return fallback;
    const v = getComputedStyle(el).getPropertyValue(name).trim();
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : fallback;
  }

  function initDUCarousel(root = document) {
    const sections = root.querySelectorAll('[data-du][data-layout="carousel"]');
    if (!sections.length) return;

    sections.forEach((du) => {
      const track = du.querySelector("[data-du-track]");
      const prev = du.querySelector("[data-du-prev]");
      const next = du.querySelector("[data-du-next]");
      if (!track || !prev || !next) return;

      if (du.dataset.duCarouselInited === "1") return;
      du.dataset.duCarouselInited = "1";

      const gap = readCssVarNumber(du, "--du-gap", 12);
      const perDesktop = Math.max(1, Math.round(readCssVarNumber(du, "--du-perview-desktop", 3)));
      const perMobile = Math.max(1, Math.round(readCssVarNumber(du, "--du-perview-mobile", 1)));

      function currentPerView() {
        return window.matchMedia("(max-width: 768px)").matches ? perMobile : perDesktop;
      }

      function step() {
        const per = currentPerView();
        const slot = (track.clientWidth - gap * (per - 1)) / per;
        return slot + gap;
      }

      prev.addEventListener("click", (e) => {
        e.preventDefault();
        track.scrollBy({ left: -step(), behavior: "smooth" });
      });

      next.addEventListener("click", (e) => {
        e.preventDefault();
        track.scrollBy({ left: step(), behavior: "smooth" });
      });
    });
  }

  // -------------------------
  // 2) Cart drawer remove (line)
  // -------------------------
  function bindRemoveButtons() {
    if (window.__duRemoveBound) return;
    window.__duRemoveBound = true;

    document.addEventListener(
      "click",
      async (e) => {
        const btn = e.target.closest(CART_DRAWER_REMOVE_SELECTOR);
        if (!btn) return;

        // sadece DU modülü olan sayfalarda devreye girsin
        if (!document.querySelector("[data-du]")) return;

        const line = getLineFromRemoveButton(btn);
        if (!line) return;

        e.preventDefault();
        e.stopPropagation();

        try {
          await changeLine(line, 0);
          await refreshMiniCartHard();
        } catch (err) {
          console.error(err);
          // sessiz fallback: event ile refresh
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      },
      true
    );
  }

  // -------------------------
  // 3) Add to cart intercept (single request)
  // -------------------------
  function bindUpsellSubmit() {
    const duRoot = document.querySelector("[data-du]");
    const mainForm = findMainProductForm();
    if (!duRoot || !mainForm) return;

    if (mainForm.dataset.duBound === "1") return;
    mainForm.dataset.duBound = "1";

    mainForm.addEventListener(
  "submit",
  async (e) => {
    const selected = getSelectedUpsellVariantIds(duRoot);
    if (!selected.length) return; // upsell yoksa tema normal çalışsın

    // ✅ Re-entry / loop kilidi (biz submit tetiklersek tekrar yakalamasın)
    if (mainForm.dataset.duBypass === "1") return;

    // ✅ double submit kilidi
    if (mainForm.dataset.duLock === "1") return;
    mainForm.dataset.duLock = "1";

    e.preventDefault();
    e.stopPropagation();

    const mainVariantId = getMainVariantIdFromForm(mainForm);
    if (!mainVariantId) {
      mainForm.dataset.duLock = "0";
      return;
    }

    const btn = mainForm.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;

    // ✅ qty formdan oku (tema quantity input’u varsa)
    const qtyEl = mainForm.querySelector('[name="quantity"]');
    const mainQty = Math.max(1, parseInt(qtyEl ? qtyEl.value : "1", 10) || 1);

    try {
      // ✅ Sepette ana ürün var mı?
      const cart = await fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
      const mainInCart = cart.items.some(it => String(it.variant_id) === String(mainVariantId));

      // ✅ Upsell items (her zaman ekle)
      const upsellItems = selected.map((vid) => ({
        id: Number(vid),
        quantity: 1,
        properties: {
          _du_upsell: "1",
          _du_parent: String(mainVariantId)
        }
      }));

      if (mainInCart) {
        // ✅ Ana ürün zaten sepette: +1 ekleme, sadece upsell ekle
        await addItems(upsellItems);
        await refreshMiniCartHard();
        return;
      }

      // ✅ Ana ürün sepette yok: ana ürünü (qty kadar) + upsell’i tek requestte ekle
      const items = [
        { id: Number(mainVariantId), quantity: mainQty },
        ...upsellItems
      ];

      await addItems(items);
      await refreshMiniCartHard();

    } catch (err) {
      console.error(err);
      alert("Sepete eklenirken hata oluştu. Lütfen tekrar deneyin.");
    } finally {
      if (btn) btn.disabled = false;
      setTimeout(() => {
        mainForm.dataset.duLock = "0";
      }, 400);
    }
  },
  true // capture
);

  }

  // -------------------------
  // Boot
  // -------------------------
  onReady(() => {
    initDUCarousel(document);
    bindRemoveButtons();
    bindUpsellSubmit();
  });

  document.addEventListener("shopify:section:load", (e) => {
    initDUCarousel(e.target);
    bindRemoveButtons();
    bindUpsellSubmit();
  });
})();

// =========================================
// DU Discount -> Mini Cart dynamic display
// =========================================
function getDUDiscountPct() {
  const du = document.querySelector("[data-du]");
  if (!du) return 0;
  const raw = du.getAttribute("data-du-discount") || "0";
  const n = parseFloat(String(raw).replace(",", "."));
  return Number.isFinite(n) ? Math.max(0, Math.min(95, n)) : 0;
}

// Keşif seti handle (senin ürün handle’ın)
const DU_KESIF_HANDLE = "eternal-whisper-koleksiyon-kesif-seti";

// İndirim uygulanacak ürün handle listesi (senin belirlediğinler)
const DU_DISCOUNT_HANDLES = ["alchemy", "grace", "remembrance", "subrosa", "wound-of-heart"];

function getHandleFromItem(item) {
  const url = item && item.url ? item.url : "";
  if (!url.includes("/products/")) return "";
  return url.split("/products/")[1].split("?")[0].split("/")[0];
}

function formatTLFromCents(cents) {
  // theme.Currency.formatMoney kullanmak daha doğru ama yoksa fallback
  try {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === "function") {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
  } catch (e) {}
  return (cents / 100).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "TL";
}

/**
 * Mini cart HTML üretiminde:
 * - fiyat satırını tek satır old+new yap
 * - yüzdeyi DU’dan oku
 * - keşif seti yoksa indirimi kapat
 */
function duPriceLineHTML(product, qty) {
  const pct = getDUDiscountPct();
  const handle = getHandleFromItem(product);

  const hasKesif = (window.__duHasKesif === true); // generateCart içinde set edeceğiz
  const eligible = DU_DISCOUNT_HANDLES.includes(handle);

  const base = Number(product.price); // cents
  const discounted = Math.round(base * (1 - pct / 100));

  const showDiscount = hasKesif && eligible && pct > 0;

  const oldMoney = formatTLFromCents(base);
  const newMoney = formatTLFromCents(showDiscount ? discounted : base);

  return `
    <div class="mc-price-line">
      ${showDiscount ? `<span class="mc-old">${oldMoney}</span>` : ``}
      <span class="mc-new">${newMoney}</span>
      <span class="mc-mult">x ${qty}</span>
    </div>
  `;
}
